import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCombo = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    xmlSpace='preserve'
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g transform='matrix(1,0,0,1,-117,-44)'>
      <g transform='matrix(1,0,0,1,90,18)'>
        <rect
          x={27}
          y={26}
          width={24}
          height={24}
          style={{
            fill: 'none',
          }}
        />
        <g transform='matrix(1,0,0,1,27,26)'>
          <path d='M12,19.482L6.367,19.482C4.029,19.482 2.5,17.762 2.5,15.372C2.5,12.982 3.771,11.276 6.966,11.276L10.205,11.276C10.295,10.813 10.518,10.386 10.859,10.046C11.176,9.729 11.575,9.524 12,9.43L12,4.97L8.189,4.97C8.091,5.551 7.824,6.089 7.399,6.514C6.841,7.071 6.108,7.35 5.377,7.35C4.645,7.35 3.913,7.071 3.356,6.514C2.816,5.975 2.519,5.258 2.519,4.494C2.519,3.73 2.816,3.013 3.356,2.474C4.471,1.358 6.284,1.359 7.399,2.474C7.825,2.899 8.092,3.436 8.189,4.018L12,4.018L12,0.996C12,0.72 12.224,0.496 12.5,0.496C12.776,0.496 13,0.72 13,0.996L13,22.996C13,23.271 12.776,23.496 12.5,23.496C12.224,23.496 12,23.271 12,22.996L12,19.482ZM12,10.407C11.827,10.478 11.668,10.583 11.532,10.719C11.262,10.99 11.114,11.348 11.114,11.73C11.114,12.112 11.263,12.471 11.533,12.741C11.667,12.875 11.827,12.976 12,13.044L12,10.407ZM12,14.049C11.571,13.95 11.177,13.733 10.858,13.413C10.528,13.084 10.309,12.673 10.215,12.228L6.366,12.228C4.52,12.228 3.452,13.515 3.452,15.372C3.452,17.23 4.595,18.529 6.366,18.529L12,18.529L12,14.049ZM4.029,5.842C4.774,6.584 5.982,6.584 6.725,5.842C7.084,5.482 7.282,5.004 7.282,4.495C7.282,3.986 7.084,3.508 6.725,3.148C5.981,2.406 4.773,2.406 4.029,3.148C3.67,3.508 3.472,3.986 3.472,4.495C3.472,5.004 3.67,5.482 4.029,5.842ZM14.033,22.499L14.033,21.498L16.829,21.498L14.827,19.496L14.033,19.496L14.033,18.495L17.795,18.495L18.925,17.069C17.309,17.356 15.673,17.508 14.033,17.523L14.033,16.504C17.236,16.441 19.087,16.084 19.531,15.852L19.531,6.685L18.086,10.509C18.058,10.586 18.012,10.655 17.952,10.71C16.841,11.702 15.485,12.366 14.033,12.64L14.033,11.615C15.197,11.364 16.285,10.823 17.194,10.036L19.526,3.861C19.418,2.832 17.235,1.725 14.033,1.531L14.033,0.528C17.801,0.739 20.532,2.136 20.533,3.941L20.533,16.476C20.53,16.497 20.526,16.518 20.52,16.538C20.517,16.572 20.51,16.606 20.5,16.638C20.487,16.671 20.472,16.702 20.453,16.731C20.444,16.75 20.435,16.769 20.425,16.786L18.431,19.306C18.384,19.365 18.324,19.413 18.256,19.446C18.188,19.479 18.114,19.496 18.038,19.496L16.244,19.496L19.393,22.645C19.439,22.691 19.476,22.747 19.501,22.807C19.527,22.868 19.54,22.933 19.54,22.999C19.54,23.065 19.527,23.13 19.502,23.191C19.477,23.251 19.44,23.307 19.393,23.353C19.347,23.4 19.292,23.437 19.231,23.462C19.17,23.487 19.105,23.5 19.039,23.5C18.973,23.5 18.908,23.487 18.848,23.462C18.787,23.437 18.732,23.4 18.685,23.354L17.831,22.499L14.033,22.499ZM14.033,4.002L17.537,4.002C17.67,4.002 17.797,4.055 17.891,4.148C17.985,4.242 18.037,4.37 18.037,4.502C18.037,4.635 17.985,4.762 17.891,4.856C17.797,4.95 17.67,5.003 17.537,5.003L14.033,5.003L14.033,4.002Z' />
        </g>
      </g>
    </g>
  </svg>
);
export default SvgCombo;
